import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Gallery from './views/Gallery.vue'
import About from './views/About.vue'
import Tester from './views/Tester.vue'
import Contact from './views/Contact.vue'
import Initiative from './views/Initiative.vue'
import Post from './views/Post.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/tester',
      name: 'tester',
      component: Tester
    },
    
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/initiative',
      name: 'initiative',
      component: Initiative
    },
    {
      path: '/initiative/:slug',
      name: 'post',
      component: Post
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      console.log(savedPosition)
      
     return new Promise(async (res, err) => {
        setTimeout(() => {
          res(savedPosition)
        }, 500);
     })
    } else {
      return { x: 0, y: 0 };
    }
  }
})
